export function getObjectByCustomerId(dataArray, targetCustomerName) {
    if (targetCustomerName === 'all') {
        return dataArray
    }
    else {
        return dataArray.filter(obj => obj.customer_name === targetCustomerName);
    }
}